// Стек смонтированных <BackButton>: выигрывает последний смонтированный — кнопка
// принадлежит верхнему экрану.

export type BackButtonEntry = {
  id: string
  onPress: () => void
}

let stack: BackButtonEntry[] = []
const listeners = new Set<() => void>()

function notify() {
  listeners.forEach((listener) => listener())
}

export function pushBackButtonEntry(entry: BackButtonEntry) {
  stack = [...stack, entry]
  notify()
}

export function updateBackButtonEntry(id: string, onPress: () => void) {
  stack = stack.map((entry) => (entry.id === id ? { id, onPress } : entry))
  notify()
}

export function removeBackButtonEntry(id: string) {
  stack = stack.filter((entry) => entry.id !== id)
  notify()
}

export function subscribeBackButtonStack(listener: () => void) {
  listeners.add(listener)
  return () => listeners.delete(listener)
}

export function getTopBackButtonEntry(): BackButtonEntry | null {
  return stack.length > 0 ? stack[stack.length - 1]! : null
}
